import {
    apiRequest,
    // employeeWFHList,
    angkaKreditList,
    angkaKreditInactive
    // employeeWFHInactive,
    // employeeWFHActive
} from "../../../../../services/adapters/kepegawaian/pengajuanAngkaKreditService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", angkaKreditList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", angkaKreditInactive, {
            body: query
        }, true)
    }

    // fetchActive = async (query) => {
    //     return await apiRequest("post", employeeWFHActive, {
    //         body: query
    //     }, true)
    // }
}

export default DataTableRepository